module.exports = __webpack_public_path__ + "img/popular2.78ee4805.png";